// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff58202a","455":"1d19f327","977":"c8c5e7d6"}[chunkId] + ".chunk.js";
};